import { EP_ALL_ACTIVE_USERS, EP_GET_LAST_LOCKED_YEAR_MONTH } from '../constants/endpointConstants';
import api from './Api';

//#region Common
const getAllActiveUsers = async () => {
    const response = await api.get(`${EP_ALL_ACTIVE_USERS}`);
    return response.data;
}

const getLastLockedYearMonth = async () => {
    const response = await api.get(`${EP_GET_LAST_LOCKED_YEAR_MONTH}`);
    return response.data;
}
//#endregion

export {getAllActiveUsers, getLastLockedYearMonth}